function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Twitter"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 5",
  width: 20,
  height: 20,
  fill: "#C4C4C4",
  fillOpacity: 0.01
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M17.4734 4.72498C18.2842 4.23981 18.8908 3.4762 19.18 2.57665C18.4182 3.02914 17.5845 3.34765 16.715 3.51832C16.1304 2.89404 15.3559 2.48025 14.512 2.34121C13.668 2.20217 12.8018 2.34564 12.0477 2.74936C11.2937 3.15308 10.694 3.79445 10.3418 4.5739C9.98964 5.35335 9.90465 6.22727 10.1 7.05998C8.55644 6.98248 7.04639 6.58127 5.66789 5.8824C4.28939 5.18353 3.07324 4.20262 2.09837 3.00332C1.76503 3.57832 1.57337 4.24498 1.57337 4.95498C1.573 5.59415 1.7304 6.22352 2.0316 6.78726C2.33281 7.351 2.7685 7.83168 3.30004 8.18665C2.6836 8.16703 2.08076 8.00047 1.5417 7.70082V7.75082C1.54164 8.64727 1.85173 9.51613 2.41935 10.21C2.98698 10.9038 3.77718 11.3799 4.65587 11.5575C4.08402 11.7122 3.48448 11.735 2.90253 11.6241C3.15045 12.3955 3.63336 13.07 4.28367 13.5533C4.93398 14.0365 5.71913 14.3043 6.5292 14.3191C5.15406 15.3987 3.45577 15.9842 1.70754 15.9816C1.39785 15.9817 1.08843 15.9636 0.780869 15.9275C2.55543 17.0685 4.62115 17.674 6.73087 17.6716C13.8725 17.6716 17.7767 11.7566 17.7767 6.62665C17.7767 6.45998 17.7725 6.29165 17.765 6.12498C18.5244 5.57579 19.18 4.89573 19.7009 4.11665L19.7025 4.11415V4.11415C19.0067 4.42248 18.2592 4.63082 17.4734 4.72498Z",
  fill: "white"
}));

var SvgTwitterLogo = function SvgTwitterLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitterLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter_logo.32b96be5.svg";
export { ForwardRef as ReactComponent };